import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Event from './Event/Event';
import { filterEventsForTheme } from '../../lib/discoveryThemes';

export const Events = ({ theme = 'wildlife' }) => {
    const { events, isLoading } = useSelector((state) => state.events);
    const visibleEvents = filterEventsForTheme(events, theme);

    if (!visibleEvents.length && !isLoading) {
        return <div className="atlas-empty-state">No events are available for this theme right now. Try another theme or come back later.</div>;
    }

    return (
        isLoading ? (
            <div className="atlas-loading-state">
                <CircularProgress />
            </div>
        ) : (
            <Grid container alignItems="stretch" spacing={3}>
                {visibleEvents.map((item) => (
                    <Grid key={item._id || item.item_type_id || item.id || item.title} item xs={12} sm={6}>
                        <Event eventInfo={item} />
                    </Grid>
                ))}
            </Grid>
        )
    )
}
